import React from 'react';
import './Community.css';

const Community = () => {
  return (
    <section id="community" className="community-section">
      <div className="community-image-wrapper-full">
        <img 
          src="/images/community.jpg" 
          alt="Community Welfare Initiative" 
          className="community-full-image" 
          loading="lazy"
          decoding="async"
        />
      </div>
    </section>
  );
};

export default Community;
